const moblileNavBtn = document.querySelector('.mobile-nav-btn')
const navigationLinks = document.querySelector('.navigation-links')
const header = document.querySelector('header')
const websiteSlidein = document.querySelector('.website-slidein')

if (document.documentElement.clientWidth < 992) navigationLinks.style.display = 'none';

moblileNavBtn.addEventListener("click", () => {
    //navigationLinks.classList.toggle('display_none')

    if (navigationLinks.style.display == 'none'){
        navigationLinks.style.display = 'block'
    }
    else{
        navigationLinks.style.display = 'none'
    }
})

window.addEventListener("resize", () => {
    if (window.innerWidth >= 992) {
        navigationLinks.style.display = 'block'
    }

    if (window.innerWidth < 992) {
        navigationLinks.style.display = 'none'
    }
});


function resolveIt(header) {
    var waitTime = 0
    if(websiteSlidein) waitTime = 4500

    return new Promise(resolve => {
        setTimeout(() => {
            header.classList.add('header-z')
        }, waitTime);
    });
}

async function addHeaderZ(header) {
    
    const result = await resolveIt(header);
}

// adds z index so that header would be sticky after 4.5s (animation ending)
if (window.innerWidth < 999999) addHeaderZ(header)
